"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ebebeb;}.cls-3{opacity:0.12;isolation:isolate;}.cls-4{fill:#ccc;}")), /*#__PURE__*/React.createElement("title", null, "tracker-hi"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("g", {
    id: "cb87331c-9e5e-4f27-b81b-53371fc55958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba312d43-2cef-4605-ac6b-9603663549d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7c2d488-061f-4336-be53-c358e2bc97a6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 192,
    height: 191.5
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.12,79.29c0,42-62.88,96.54-62.88,96.54S33.36,121.26,33.36,79.29a62.88,62.88,0,0,1,125.76,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.24,173.83S34.4,120.16,33.38,78.34v1c0,42,62.88,96.54,62.88,96.54s62.88-54.57,62.88-96.54v-1C158.07,120.16,96.24,173.83,96.24,173.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96,
    cy: 79.26,
    r: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,52.45A29.29,29.29,0,0,1,125.26,80.5c0-.41,0-.82,0-1.24a29.29,29.29,0,0,0-58.58,0c0,.42,0,.83,0,1.24A29.29,29.29,0,0,1,96,52.45Z",
    transform: "translate(0 0)"
  })));
}

var _default = ic_tracker;
exports.default = _default;